module.exports = "//static.hsappstatic.net/pricing-pages-lib/static-1.29318/images/keyFeatures/customerAgent_callout.png"